import { Link } from "react-router-dom";
import { useEffect } from "react";
import { Anchor, ArrowRight, Calendar } from "lucide-react";
import { POSTS, formatDate } from "@/lib/blogPosts";

export default function BlogIndex() {
    useEffect(() => {
        document.title = "Blog — Bosun's Mate";
        const desc = document.querySelector('meta[name="description"]');
        if (desc) desc.setAttribute("content", "Insights on vessel maintenance, digital logbooks, marine resale value, and how modern captains manage their boats.");
    }, []);

    return (
        <div data-testid="blog-index" style={{ background: "var(--bm-bg)", minHeight: "100vh", color: "var(--bm-text)" }}>
            <header style={{ padding: "18px 32px", display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "1px solid var(--bm-border-soft)" }}>
                <Link to="/" className="bm-serif" style={{ fontSize: 22, color: "var(--bm-gold)", textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 8 }}>
                    <Anchor size={18} /> Bosun&apos;s Mate
                </Link>
                <nav style={{ display: "flex", gap: 20, alignItems: "center" }}>
                    <Link to="/#features" className="bm-link" style={{ fontSize: 14 }}>Features</Link>
                    <Link to="/pricing" className="bm-link" style={{ fontSize: 14 }}>Pricing</Link>
                    <Link to="/blog" className="bm-link" style={{ fontSize: 14, color: "var(--bm-gold)" }}>Blog</Link>
                    <Link to="/register" className="bm-btn bm-btn-gold" style={{ padding: "8px 16px", fontSize: 13 }}>Start free</Link>
                </nav>
            </header>

            <section style={{ maxWidth: 880, margin: "0 auto", padding: "60px 32px 40px" }}>
                <div style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: "0.18em", color: "var(--bm-gold)", marginBottom: 12 }}>
                    The Log Book
                </div>
                <h1 className="bm-serif" style={{ fontSize: "clamp(36px, 5vw, 56px)", margin: "0 0 14px", fontWeight: 500, lineHeight: 1.1 }}>
                    Notes from the wheelhouse.
                </h1>
                <p style={{ fontSize: 17, color: "var(--bm-text-muted)", lineHeight: 1.6, maxWidth: 640 }}>
                    Field notes on vessel maintenance, digital logbooks, marine resale, and the small habits that keep captains ahead of the season.
                </p>
            </section>

            <section style={{ maxWidth: 880, margin: "0 auto", padding: "0 32px 80px" }}>
                {POSTS.map((post) => (
                    <article
                        key={post.slug}
                        data-testid={`blog-post-card-${post.slug}`}
                        style={{
                            padding: "28px 0",
                            borderTop: "1px solid var(--bm-border-soft)",
                        }}
                    >
                        <div style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 12, color: "var(--bm-text-muted)", marginBottom: 8 }}>
                            <Calendar size={12} />
                            <time dateTime={post.date}>{formatDate(post.date)}</time>
                        </div>
                        <h2 className="bm-serif" style={{ fontSize: "clamp(24px, 3vw, 32px)", margin: "0 0 10px", fontWeight: 500, lineHeight: 1.25 }}>
                            <Link to={`/blog/${post.slug}`} style={{ color: "var(--bm-text)", textDecoration: "none" }}>{post.title}</Link>
                        </h2>
                        <p style={{ fontSize: 15, color: "var(--bm-text-muted)", lineHeight: 1.65, margin: "0 0 14px", maxWidth: 720 }}>
                            {post.excerpt}
                        </p>
                        <Link
                            to={`/blog/${post.slug}`}
                            data-testid={`blog-post-readmore-${post.slug}`}
                            style={{ color: "var(--bm-gold)", textDecoration: "none", fontSize: 14, display: "inline-flex", alignItems: "center", gap: 6 }}
                        >
                            Read more <ArrowRight size={14} />
                        </Link>
                    </article>
                ))}
            </section>

            <footer style={{ borderTop: "1px solid var(--bm-border-soft)", padding: "24px 32px", textAlign: "center", color: "var(--bm-text-dim)", fontSize: 13 }}>
                <Link to="/" className="bm-link">Back to home</Link> · <Link to="/pricing" className="bm-link">Pricing</Link>
            </footer>
        </div>
    );
}
